<template>
  <div class="trend-block">
    <div class="box-title">
      {{ $t('Trend.title') }}
    </div>
    <div class="trend-row">
      <el-button type="default" @click="decrementDate" icon="el-icon-caret-left" size="mini" ></el-button>
      <el-date-picker
        v-model="selectedDate"
        class="date-picker"
        size="small"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="選擇日期">
      </el-date-picker>
      <el-button type="default" @click="incrementDate" icon="el-icon-caret-right" size="mini"></el-button>
      <!-- <el-date-picker
        v-model="dateRange"
        size="small"
        style="margin-top: 15px"
        class="filter-item"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="開始日期"
        end-placeholder="結束日期">
      </el-date-picker> -->
    </div>
    <el-row>
      {{ $t('Trend.dayHint1') }}
      <el-input
        v-model="query.days"
        :placeholder="$t('Trend.day')"
        size="small"
        class="filter-item"
        style="width: 50px;"
      />
      {{ $t('Trend.dayHint2') }}
    </el-row>

    <el-row>
      <span class="mr-20">{{ $t('Trend.standardDeviationCtrl') }}:</span> 
      <el-radio v-model="showDeviation" :label="1">{{ $t('Trend.show') }}</el-radio>
      <el-radio v-model="showDeviation" :label="0">{{ $t('Trend.hide') }}</el-radio>
    </el-row>

    <el-row>
      {{ $t('Trend.verticalAxisCtrl') }}:
      <el-select v-model="yRange"  size="small" class="filter-item" :placeholder="$t('Element.selectPlaceholder')"  clearable>
        <el-option  :label="$t('Trend.verticalAxisDefault')" :value="0" />   
        <el-option  :label="$t('Trend.verticalAxisCustomize')" :value="1" />       
      </el-select>

      <el-input v-if="yRange == 1" size="small" v-model="yStart" class="filter-item" :placeholder="$t('Trend.verticalAxisFrom')" />
      <el-input v-if="yRange == 1" size="small" v-model="yEnd" class="filter-item" :placeholder="$t('Trend.verticalAxisTo')" />
    </el-row>

    <el-button
      class="bt-draw"
      size="small"
      type="primary"
      @click="getTrendChart()"
    >
      {{ $t('Trend.plot') }}
    </el-button>

    <p v-if="!chartDataExist" class="font-b font-df"> {{ $t('Trend.empty') }} </p>  

    <div style="width:100%; height:400px">
      <v-chart
        :option="trendChart"
        :theme="chartsTheme"
        :update-options="{ notMerge: true}" 
        style="width: 100%; height:100%"
        autoresize />
    </div>
    <p class="font-s">{{ $t('Trend.chartHint') }}</p>

  </div>
</template>
<script>
import { mixins } from '@/views/common/mixins.js'
import moment from 'moment-timezone'

export default {
  // 日用水趨勢
  name: 'Trend',
  mixins: [mixins],
  data() {
    return {
      // dateRange: [this.parseDateTime(new Date().toISOString()), this.parseDateTime(new Date().toISOString())],
      query: {
        start: this.parseDateTime(new Date().toISOString()),
        end: this.parseDateTime(new Date().toISOString()),
        days: 30
      },
      selectedDate: moment().format('YYYY-MM-DD'), // 選擇的日期
      queryDays: undefined, // 紀錄該次請求的 days
      chartDataExist: false, // 是否有圖表資料
      xAxisData: [], // x軸 日期時間
      flowLine: [],
      averageLine: [],
      avgPlus1Dev: [],
      avgPlus2Dev: [],
      avgPlus3Dev: [],
      avgMinus1Dev: [],
      avgMinus2Dev: [],
      avgMinus3Dev: [],

      yRange: 0,
      yStart:undefined, 
      yEnd:undefined, 

      showDeviation: 1, // 是否顯示標準差線圖 (0:不顯示/ 1:顯示)
      avg1DevOpacity: 0.8, // 調整與原系統相同的透明度
      avg2DevOpacity: 0.8, // 調整與原系統相同的透明度
      avg3DevOpacity: 0.8, // 調整與原系統相同的透明度
      
      debounceTimeout: null
    }
  },
  computed: {
    currentWaterId() {
      return JSON.parse(localStorage.getItem('currentProfile')).waterId
    },

    trendChart() {
      let _this = this  
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            const tooltipData = params[0].data[2]
            if (tooltipData.isVisible) {
              return `<b>${_this.$t('Trend.logTime')}:</b> ${tooltipData.recordedOn.substring(11,19)} <br/>
                    <b>${_this.$t('Trend.totalizerLog')}:</b> ${tooltipData.volume} (m3) <br/>
                    <p style="color: #4791DC; margin: 0"><b>${_this.$t('Trend.instantFlow')}:</b> ${tooltipData.value} (m³/h) </p>
                    <p style="color: #EC815B; margin: 0"><b>` + _this.queryDays + `${_this.$t('Trend.dayAverage')}:</b> ${tooltipData.average} (m³/h)</p>
                    <b>${_this.$t('Trend.standardDeviation')}:</b> ${tooltipData.standardDeviation} <br/>`
            } else {
              return null
            }
            
          },
        },
        xAxis: {
          type: 'time',
          boundaryGap: false,
          min: this.$moment(_this.query.start).startOf('day').format("YYYY-MM-DD HH:mm"),
          max: this.$moment(_this.query.start).add(1, 'days').add(1, 'minutes').format("YYYY-MM-DD HH:mm"),
          // interval: 3600 * 1000,
          // minInterval: 1 * 60 * 60 * 1000,
          maxInterval: 3 * 60 * 60 * 1000,
          axisLabel: {
            margin:16,  // 調整標籤與軸線之間的距離
            formatter: function (value) {
              return moment(value).format('HH:mm')
            }
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('Trend.flow'),
          min: _this.yStart,       
          max: _this.yEnd,
          axisLabel:{
            margin:16  // 調整標籤與軸線之間的距離
          } 
        },   
        dataZoom: [
          {   
            type: 'inside',
            start: 0, // 調整資料縮放顯示
            end: 100 // 調整資料縮放顯示
          }
        ],
        series: [
          {
            data: _this.flowLine,
            type: 'line',
            name: '瞬間流量',
            lineStyle: {
              color: '#1F77B4' // 調整與原系統相同色碼
            },
            symbol: 'circle',
            connectNulls: false,
            z:5, // 調整疊加順序
            silent: true, 
          },
          {
            data: _this.averageLine,
            type: 'line',
            name: '平均流量',
            lineStyle: {
              color: '#A2652E', // 調整與原系統相同色碼
              opacity: _this.showDeviation
            },
            symbol: 'none',
            z:4, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgPlus1Dev,
            type: 'line',
            name: 'avg+1',
            areaStyle: {
              color: '#feb779', // 調整與原系統相同色碼
              opacity: _this.avg1DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:3, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgMinus1Dev,
            type: 'line',
            name: 'avg-1',
            areaStyle: {
              color: '#feb779', // 調整與原系統相同色碼
              opacity: _this.avg1DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:3, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgPlus2Dev,
            type: 'line',
            name: 'avg+2',
            areaStyle: {
              color: '#fdd1a9', // 調整與原系統相同色碼
              opacity: _this.avg2DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:2, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgMinus2Dev,
            type: 'line',
            name: 'avg-2',
            areaStyle: {
              color: '#fdd1a9', // 調整與原系統相同色碼
              opacity: _this.avg2DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:2, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgPlus3Dev,
            type: 'line',
            name: 'avg+3',
            areaStyle: {
              color: '#fbe2cb', // 調整與原系統相同色碼
              opacity: _this.avg3DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:1, // 調整疊加順序
            silent: true, 
            connectNulls: false
          },
          {
            data: _this.avgMinus3Dev,
            type: 'line',
            name: 'avg-3',
            areaStyle: {
              color: '#fbe2cb', // 調整與原系統相同色碼
              opacity: _this.avg3DevOpacity
            },
            lineStyle: {
              opacity: 0
            },
            symbol: 'none',
            z:1, // 調整疊加順序
            silent: true, 
            connectNulls: false
          }
        ]
      }
      return option
    }
  },
  watch: {
    selectedDate: function(val) {
      if (val) {
        this.query.start = val
        this.query.end = val
      }
    },
    // 是否顯示標準差線圖及透明度調整
    showDeviation: function(val) {
      if (val) { // 顯示
        this.avg1DevOpacity = 0.8 // 調整與原系統相同的透明度
        this.avg2DevOpacity = 0.8 // 調整與原系統相同的透明度
        this.avg3DevOpacity = 0.8 // 調整與原系統相同的透明度
      } else { // 隱藏
        this.avg1DevOpacity = 0
        this.avg2DevOpacity = 0
        this.avg3DevOpacity = 0
      }
    }
    // dateRange: function(val) {
    //   if (val) {
    //     this.query.start = val[0]
    //     this.query.end = val[1]
    //   } else {
    //     this.query.start = undefined
    //     this.query.end = undefined
    //   }
    // },
  },
  created() {
    this.getTrendChart()
  },

  methods: {
    // 趨勢圖圖表
    async getTrendChart() {
      this.resetChart()
      if (this.currentWaterId) {
        this.resetChart() // 圖表初始化
        // let datetime = []
        let flowList = []
        let avgFlowList = []
        let avgPlus1 = []
        let avgPlus2 = []
        let avgPlus3 = []
        let avgMinus1 = []
        let avgMinus2 = []
        let avgMinus3 = []

        if (this.yRange==0){
          this.yStart=undefined
          this.yEnd=undefined        
        }

        await this.axios.get('/api/report/profile/' + this.currentWaterId + '/rawdata', {params: this.query}).then(res => {
          this.queryDays = this.query.days // 紀錄本次請求的 days
          // console.log('res', res)
          if (res.data.length > 0) {
            this.chartDataExist = true // 圖表資料存在
            let data = res.data
            data.forEach(element => {
              let formatedTime = this.parseDateTimeToHHMMSS(element.recordedOn) // 紀錄日期格式化
              // 瞬間流量
              flowList.push([
                new Date(formatedTime),
                element.visible ? (element.flow == undefined ? '' : element.flow.toFixed(3)): null, // value 決定線的值, 如 visible = true 才顯示
                {
                  recordedOn: formatedTime,
                  volume: element.volumeAdjusted != null ? element.volumeAdjusted.toFixed(2): (element.volume != undefined ? element.volume.toFixed(2): ''), // 若有人工調整指針 則呈現人工調整後的值
                  flow: element.flow == undefined ? '' : element.flow.toFixed(3),
                  average: element.average == undefined ? '' : element.average.toFixed(2),
                  standardDeviation: element.standardDeviation == undefined ? '' : element.standardDeviation.toFixed(2),
                  value: element.visible ? (element.flow == undefined ? '' : element.flow.toFixed(3)): null, // value 決定線的值, 如 visible = true 才顯示
                  isVisible: element.visible  
                }
              ])
              // 近 n 日平均值
              avgFlowList.push([
                new Date(formatedTime),
                element.visible ? element.average: null // value 決定線的值
              ])
              // avg + 1 Dev
              avgPlus1.push([
                new Date(formatedTime),
                element.visible ? (element.average + element.standardDeviation) : null // value 決定線的值
              ])
              // avg + 2 Dev
              avgPlus2.push([
                new Date(formatedTime),
                element.visible ? (element.average + 2 * element.standardDeviation) : null// value 決定線的值
              ])
              // avg + 3 Dev
              avgPlus3.push([
                new Date(formatedTime),
                element.visible ? (element.average + 3 * element.standardDeviation) : null// value 決定線的值
              ])
              // avg - 1 Dev
              avgMinus1.push([
                new Date(formatedTime),
                element.visible ? (element.average - element.standardDeviation) : null// value 決定線的值
              ])
              // avg - 2 Dev
              avgMinus2.push([
                new Date(formatedTime),
                element.visible ? (element.average - 2 * element.standardDeviation) : null// value 決定線的值
              ])
              // avg - 3 Dev
              avgMinus3.push([
                new Date(formatedTime),
                element.visible ? (element.average - 3 * element.standardDeviation) : null // value 決定線的值
              ])
            });
          } else {
            this.chartDataExist = false // 無圖表資料
          }
        })
        if (this.chartDataExist) { // 圖表資料存在
          // this.xAxisData = datetime // 圖表x軸
          // this.xAxisData = Array.from({ length: 25 }, (_, index) => moment().startOf('day').add(index, 'hours').format('HH:mm')); // 畫滿24小時
          // console.log('xAxisData', this.xAxisData)
          this.flowLine = flowList
          this.averageLine = avgFlowList
          this.avgPlus1Dev = avgPlus1
          this.avgPlus2Dev = avgPlus2
          this.avgPlus3Dev = avgPlus3
          this.avgMinus1Dev = avgMinus1
          this.avgMinus2Dev = avgMinus2
          this.avgMinus3Dev = avgMinus3
          // console.log('datetime', datetime)
        }
      }
      
    },
    // 增加一天
    incrementDate() {
        const newDay = moment(this.selectedDate).add(1, 'days').format('YYYY-MM-DD');
        this.selectedDate = newDay
        this.debouncePaint(this.rePaint, 2000)
    },
    // 減少一天
    decrementDate() {
        const newDay = moment(this.selectedDate).subtract(1, 'days').format('YYYY-MM-DD');
        this.selectedDate = newDay
        this.debouncePaint(this.rePaint, 2000)
    },
    // 重新繪製圖表
    async rePaint() {
      // 判斷要畫哪個圖表
      await this.getTrendChart()
 
      this.$forceUpdate()
    },
    // 渲染 debounce 防止狂按左右鍵 狂發api請求
    debouncePaint(fn, delay) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }
      this.debounceTimeout = setTimeout(() => {
        fn()
      }, delay)
    },
    resetChart(){
      this.flowLine = []
      this.averageLine = []
      this.avgPlus1Dev = []
      this.avgPlus2Dev = []
      this.avgPlus3Dev = []
      this.avgMinus1Dev = []
      this.avgMinus2Dev = []
      this.avgMinus3Dev = []
    }
    
  }
}
</script>
